import { $regraAcao, $regraEntidade } from "@/custom-enum/regras-enum";

export default [{
        path: '/usuarios-sesi',
        name: 'usuarios-sesi',
        component: () =>
            import ('@/views/pages/usuarios-sesi/UsuariosSesi'),
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.portal.usuariosSesi,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Usuários Sesi'
        },
    },
]
